import React, { useEffect } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchDoctor } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const DoctorDropdown = ({
  errors,
  control,
  setValue,
  getValues,
  watch,
}) => {
  const doctorName = getValues().doctor_name;
  const selectedDoctor = watch("refer_doctor_id");
  const login = useSelector((state) => state.jwtAuthreducer);
  const {
    data: doctors,
    isLoading,
    refetch,
    error,
  } = useQuery(["doctors"], () => fetchDoctor({ ...login }), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  useEffect(() => {
    refetch()
  }, [login])

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Designation</div>;

  const modifiedData = doctors?.data?.data?.map((ele) => ({
    ...ele,
    refer_doctor_id: ele.id,
  }));

  const options =
    modifiedData?.map((doctor) => ({
      value: doctor.refer_doctor_id,
      label: doctor.doctor_name,
    })) || [];

  const selectedOption = options.find(
    (option) => option.value === selectedDoctor || doctorName
  );
  return (
    <Controller
      name="refer_doctor_id"
      control={control}
      rules={{ required: "Doctor Name is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Doctor"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption.value : "";
            field.onChange(value);


            setValue("refer_doctor_id", value);
          }}
          className={`react-select-container ${errors.refer_doctor_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default DoctorDropdown;
